import React from 'react';
import './ScrollNavigation.css';

const ScrollNav = ({ sections, activeIndex, onDotClick }) => {
  return (
    <ul className="scroll-nav">
      {sections.map((_, index) => (
        <li
          key={index}
          className={`nav-line ${index === activeIndex ? 'active' : ''}`}
          onClick={() => onDotClick(index)}
        />
      ))}
    </ul>
  );
};

export default ScrollNav;
